"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var with_sufficient_service_permission_1 = require("./with-sufficient-service-permission");
exports.withSuffcientServicePermission = with_sufficient_service_permission_1.withSuffcientServicePermission;
exports.withSufficientServicePermission = with_sufficient_service_permission_1.withSufficientServicePermission;
var utilities_1 = require("./utilities");
exports.Permission = utilities_1.Permission;
exports.isSufficientPermission = utilities_1.isSufficientPermission;
